// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"d6-z"};